import React from 'react';
import { AccountContextProvider } from './AccountContext';
import { NavigationContextProvider } from './NavigationContext';
import { ToastContextProvider } from './ToastContext';
import { LanguageContextProvider } from './LanguageContext';

const AppContexts = ({ children }) => (
  <AccountContextProvider>
    <ToastContextProvider>
      <NavigationContextProvider>
        <LanguageContextProvider>{children}</LanguageContextProvider>
      </NavigationContextProvider>
    </ToastContextProvider>
  </AccountContextProvider>
);

export default AppContexts;
